import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { X } from "lucide-react";
import "./Modal.css";

export default function Modal({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  maxWidth = "480px",
  children,
  footer,
  className = ""
}) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;

    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div
        className={`custom-modal-container ${className}`}
        style={{ maxWidth }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="custom-modal-header">
          <div className="custom-modal-header-content">
            {icon && <div className="custom-modal-header-icon-wrapper">{icon}</div>}
            <div>
              {title && <h3 className="custom-modal-title">{title}</h3>}
              {subtitle && <p className="custom-modal-subtitle">{subtitle}</p>}
            </div>
          </div>
          {onClose && (
            <button className="custom-modal-close-btn" onClick={onClose} title="Close Modal">
              <X size={18} />
            </button>
          )}
        </div>

        {/* Modal Body */}
        <div className="custom-modal-body">{children}</div>

        {/* Modal Footer */}
        {footer && <div className="custom-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string
};
